import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'
import placeholder from '../assets/placeholder_elementary.png'

const StudentImage = ApplicationRecord.extend({
  static: {
    jsonapiType: 'student_images',
  },
  attrs: {
    grade: attr(),
    year: attr(),
    folder: attr(),
    needsRetake: attr(),
    accesscode: attr(),
    studentId: attr(),
    packageId: attr(),
    multiSeasonPackageId: attr(),
    // Is this access code from a PREVIOUS year, and (seniors only) which senior
    // pricelist to send them to instead. Both decided server-side against
    // SeasonCalendar -- see StudentImage#past_season?.
    pastSeason: attr(),
    seniorPastPackageId: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    imageUrl: attr(),
    ignoreBaseScope: attr(),
    newSeasonNotAvailable: attr(),
    watermarkUrl: attr(),
    student: belongsTo(),
    package: belongsTo({ persist: false }),
    orderPackages: hasMany(),
    seniorImages: hasMany(),
    poses: hasMany(),
    sharedPoses: hasMany(),
    siblingImages: attr(),
  },
  methods: {
    format() {
      const parts = this.imageUrl.split('.')

      return parts[parts.length - 1].toUpperCase()
    },
    isJPG() {
      const parts = this.imageUrl.split('.').map(part => part.toUpperCase());

      return parts.some((part) => ['JPG', 'JPEG'].includes(part.toUpperCase()));
    },
    isPNG() {
      const parts = this.imageUrl.split('.').map(part => part.toUpperCase())

      return parts.some((part) => part.toUpperCase().includes('PNG'))
    },
    image() {
      if (this.watermarkUrl) return this.watermarkUrl

      return placeholder
    },
    watermark() {
      if (this.watermarkUrl) return this.watermarkUrl

      return placeholder
    },
  },
})

export default StudentImage
